import Game from 'Game';
import { DataConflictActions } from 'State/Game/DataConflictActions';
import { GameActions } from 'State/Game/GameActions';
import { PlayerActions } from 'State/Player/PlayerActions';
import { PlayerStateHelper } from 'State/Player/PlayerStateHelper';
import { LoadtimeTrackerSingleton, LoadEvents, LoadEventType } from 'Utility/LoadtimeTracker';
import { FBTrackingEvent } from 'Utility/Tracking/FBTrackingEvent';

export function handleGBCConnected() {
    LoadtimeTrackerSingleton.trackLoadTask(LoadEvents.GB_loginFlow, LoadEventType.End);

    const playerState = PlayerStateHelper.setGBCUserID(Game.store.getState().playerState, Game.sdk.getGBUserId());

    if (!playerState.FBEvents.includes(FBTrackingEvent.FTUE_01_GbcInit)) {
        Game.sdk.gameTracking(FBTrackingEvent.FTUE_01_GbcInit);
    }

    PlayerActions.setPlayerState(playerState);
    Game.store.dispatch(DataConflictActions.fetchConflicts());
    Game.store.waitFor(DataConflictActions.setConflicts).then(() => GameActions.connectedToGBC());
}
